define(function(require, exports, module) {
    'use strict';

    var helpers = require('common/addressLookup/sourceProvider/helpers');

    module.exports = {
        ...helpers,

        /**
         * @override
         */
        parseRetrieve: function(response) {
            return this.parseResponse(response)
                .then(rawItems => {
                    return rawItems.map(item => ({
                        id: item.Id,
                        label: item.Label,
                        state: this.getStateCode(item),
                        province: item.Province,
                        city: item.City,
                        address: item.Line1,
                        address2: item.Line2,
                        zip: this.getPostalCode(item),
                        streetName: item.Street,
                        buildingNumber: item.BuildingNumber,
                        propertyNumber: item.BuildingNumber,
                        subbuilding: item.SubBuilding,
                        unitNumber: item.SubBuilding,
                        isRetrievedAddress: true
                    }));
                })
                .catch(error => {
                    throw this.createParsingError(error);
                });
        },

        getPostalCode: function(item) {
            return item.CountryIso2 === 'US'
                ? item.PostalCode.substr(0, 5)
                : item.PostalCode;
        },

        getStateCode: function(item) {
            return item.CountryIso2 === 'US'
                ? 'US-' + item.ProvinceCode
                : item.Province;
        }
    };
});
